module.exports = __webpack_public_path__ + "static/img/DE.01e81281.svg";